// extracted by mini-css-extract-plugin
export default {"cls1":"Autocomplete-cls1_mrc","cls2":"Autocomplete-cls2_G_J Autocomplete-cls1_mrc"};